module.exports = __webpack_public_path__ + "static/img/no_data.2d4d7fba.png";